// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1Ny-I","head":"Table_head__1iyma","col":"Table_col__muZAJ"};